import { Button, CircularProgress, Paper, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import Paginator from "../GeneralComponents/paginator";


export default function ScrapReportAdvanced(){

    let [isDeletingAll, setIsDeletingAll] = useState(false);
    let [pageNumber, setPageNumber] = useState(0);
    let [scrapReportsCount, setScrapReportsCount] = useState(0);
    let [scrapReports, setScrapReports] = useState([] as any[]);
    let [pattern, setPattern] = useState("");
    const [pageSize, setPageSize] = useState(10);

    function updateList(){
        StorylineServerProxy.getDeletedScrapReportsCount(pattern).then(count => {  setScrapReportsCount(count.count) });
        StorylineServerProxy.getDeletedScrapReports(pageSize, pageNumber, pattern).then(scrapReports => { setScrapReports(scrapReports) });
    }

    useEffect(() => {
        updateList();
    }, [pageNumber, pageSize, pattern]);


    function handleDeleteAllClicked(){
        if(window.confirm("Delete all scrap report?")){
            setIsDeletingAll(true);
            StorylineServerProxy.markAllScrapReportsAsDeleted().then(() => { setIsDeletingAll(false) });
        }
    }

    function handleRestoreClicked(report){
        StorylineServerProxy.restoreScrapReport(report._id).then(() => { alert("Scrap report restored"); updateList();});
    }

    return (
        <> 
            <Paper elevation={6} sx={{ padding: 4 }}>
                { isDeletingAll?<CircularProgress />:<Button color="warning" onClick={handleDeleteAllClicked}>Delete all scrap reports</Button> }
            </Paper>
            <Paginator pageNumber={pageNumber} pageSize={pageSize} itemsCount={scrapReportsCount} itemType={"Deleted scrap reports"} setPageNumber={setPageNumber} setPageSize={setPageSize} />
            <TextField placeholder="Pattern..." value={pattern} onChange={(event) => {setPattern(event.target.value)}}/>
            {
                scrapReports.map(scrapReport => {
                    return(
                        <>
                            <Paper elevation={6} sx={{ padding: 4}}>
                                { scrapReport.name } - { new Date(scrapReport.timestamp).toISOString().substring(0, 10) } - { scrapReport.bufferedNew.length } links &nbsp;
                                <Button onClick={() => { handleRestoreClicked(scrapReport)}}>Restore</Button>
                            </Paper>
                        </>
                    )
                })
            }
        </>
    )
}